// Ciro hesaplama kuralları CRUD mutation'ları.
// UNIQUE kaldırıldı — aynı (kanal + iş türü) için birden fazla kural
// tanımlanabilir (farklı pricing/fee_source kombinasyonları için).

export const CREATE_REVENUE_CALCULATION_RULE_MUTATION = `
  mutation CreateRevenueCalculationRule($object: revenue_calculation_rules_insert_input!) {
    insert_revenue_calculation_rules_one(object: $object) {
      id
      company_id
      job_type_id
      revenue_channel
      pricing_method_ids
      recurrence_type
      defined_months
      valid_job_statuses
      fee_source
      status
      description
    }
  }
`;

export const UPDATE_REVENUE_CALCULATION_RULE_MUTATION = `
  mutation UpdateRevenueCalculationRule($id: Int!, $set: revenue_calculation_rules_set_input!) {
    update_revenue_calculation_rules_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      job_type_id
      revenue_channel
      pricing_method_ids
      recurrence_type
      defined_months
      valid_job_statuses
      fee_source
      status
      description
    }
  }
`;

export const DELETE_REVENUE_CALCULATION_RULE_MUTATION = `
  mutation DeleteRevenueCalculationRule($id: Int!) {
    delete_revenue_calculation_rules_by_pk(id: $id) {
      id
    }
  }
`;
